import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";

import "../../../../Swiper/style.css";

// import required modules
import { Autoplay, Scrollbar } from "swiper";
import Prods from "./Prods";

export default function ProductCatSwiper() {
  // const [navigation, setNavigation] = useState(false);

  // useEffect(() => {
  //   if (window.innerWidth > 1024) {
  //     setNavigation(true);
  //     console.log(window.innerWidth);
  //   }
  // }, [window.innerWidth]);

  let count = [1, 2, 3, 4, 5, 6, 7, 8, 9];

  return (
    <>
      <Swiper
        slidesPerView={1}
        // spaceBetween={10}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        // pagination={{
        //   clickable: true,
        // }}
        breakpoints={{
          "@0.00": {
            slidesPerView: 1,
            spaceBetween: 3,
          },
          "@0.75": {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          "@1.00": {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          "@1.50": {
            slidesPerView: 4,
            spaceBetween: 50,
          },
        }}
        modules={[Autoplay, Scrollbar]}
        scrollbar={{ el: ".swiper-scrollbar" }}
        className="mySwiper"
        // style={{ backgroundColor: "blue" }}
      >
        <div>
          {count.map((elem) => (
            <SwiperSlide key={elem}>
              <Prods />
            </SwiperSlide>
          ))}
        </div>
      </Swiper>
    </>
  );
}
